import TestAccordingLoadingIndicator from "./TestAccordionLoadingIndicator";

export function SelectTestCardLoadingIndicator(): JSX.Element {
  return (
    <div className="flex flex-col justify-start rounded-lg p-4 border w-[255px] mr-4">
      <div className="flex justify-between mb-4">
        <div className="p-1 rounded-lg w-3/6 bg-dropDownBorder animate-pulse" />
        <div className="p-1 rounded-lg w-8 bg-dropDownBorder animate-pulse" />
      </div>
      <div>
        <div className="p-1 rounded-lg w-3/6 bg-dropDownBorder animate-pulse mb-4" />
        <div className="p-3 rounded-lg w-full bg-dropDownBorder animate-pulse" />
      </div>
    </div>
  );
}
function SelectTestLoadingIndicator({
  padding,
}: {
  padding?: string;
}): JSX.Element {
  return (
    <div>
      <div className={`py-4 border-b scroll-my-24 mb-6 ${padding}`}>
        <div className="mb-5 p-2 w-1/6 bg-dropDownBorder animate-pulse rounded-md" />
        <div className="mb-5 p-2 w-1/6 bg-dropDownBorder animate-pulse rounded-md" />
        <div className="flex ">
          <SelectTestCardLoadingIndicator />
          <SelectTestCardLoadingIndicator />
          <SelectTestCardLoadingIndicator />
        </div>
      </div>
      <TestAccordingLoadingIndicator padding={padding} />
    </div>
  );
}

export default SelectTestLoadingIndicator;
